import ComponentManager from '@/Management/ComponentManager';
import EmbeddedTypeGroupBox from '@/Controls/EmbeddedTypeGroupBox';
import EmbeddedTypeGroupBoxViewModelType from '@/ViewModels/Controls/EmbeddedTypeGroupBoxViewModel';

export default class ChangelogGrid extends EmbeddedTypeGroupBox {

    public constructor(viewModel: EmbeddedTypeGroupBoxViewModelType) {
        super(viewModel);
    }

    /**
     * @override
     * @inheritdoc 
     */
    public getControl(): JQuery<HTMLElement> {
        const baseControl = super.getControl();

        this.applyBindings(baseControl,
            {
                controlName: 'changeloggrid'
            });

        return baseControl;
    }

}

ComponentManager.setControl('ChangelogGrid', ChangelogGrid, 'RADPresentation.HTMLClient.DefaultViewExtensions');